module.exports = __webpack_public_path__ + "h5/img/海报.f746832f.png";